import styled from 'styled-components';
export const StyledDownCaratIconWrapper = styled.span.withConfig({
  displayName: "NavBarstyle__StyledDownCaratIconWrapper",
  componentId: "sc-13747rs-0"
})(({
  $iconSize
}) => {
  return {
    display: 'inline-block',
    verticalAlign: 'middle',
    fontSize: $iconSize,
    marginLeft: '4px'
  };
});